import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 12,
  },
  summaryRow: {
    backgroundColor: '#FBFBFA',
    marginTop: 4,
  },
  summaryValue: {
    color: '#282525',
    fontSize: 14,
    fontWeight: 'bold',
    padding: '10px 10px 10px 6px',
  },
  splitIcon: {
    fontSize: 18,
    marginLeft: 4,
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.text.rootColor,
  },
  inactiveCell: {
    color: theme.palette.text.disabled,
  },
  amendmentCell: {
    backgroundColor: '#FBFBFA',
  },
  feeForecastsButton: {
    marginBottom: 10,
  },
  tooltipLink: {
    color: theme.palette.text.rootColor,
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
